var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramThumbUp64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pictogram/Medium./ThumbUp64*",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bounding-box",
    fillRule: "nonzero",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }), /*#__PURE__*/React.createElement("g", {
    id: "ThumbUp64",
    transform: "translate(9.000000, 9.000000)",
    stroke: "#4F4C4D",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,33.9936523 C12,42.251885 19.1268183,41.9987569 20.5383705,41.9987569 C23.4495629,41.9987569 35.9728936,41.9987569 35.9728936,41.9987569 C37.8129581,41.9987569 39.8975279,40.7346957 40.4936327,38.5701275 C42.8937687,29.8547834 46,20.9527556 46,18.5287427 C46,16.1047299 44.1737935,14 41.2165201,14 L27.0380132,14 C28.4988268,10.837821 29.5410742,7.67134669 29.5410742,4.99515547 C29.5410742,2.09774213 28.4453378,0.0172398901 25.9938143,0.0172398901 C23.5422909,0.0172398901 22.9133242,2.06026691 22.0357196,4.05110191 C20.4190058,7.71859676 17.0074486,14.0126488 12,14.0126488 L12,33.9936523 Z",
    id: "Thumb-up",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Sleeve",
    fill: "#FFCC00",
    points: "0 42 12 42 12 14 0 14"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramThumbUp64);
export default __webpack_public_path__ + "static/media/pictogramThumbUp64.b4381df19e8d676889bb9654dc5820c7.svg";
export { ForwardRef as ReactComponent };